<!-- オーダー > 最終処分場追加 -->
<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <final-disposal-site-form />
  </v-container>
</template>

<script>
import FinalDisposalSiteForm from './_Form'

export default {
  name: 'DriverMasterFinalDisposalSiteNew',
  components: {
    FinalDisposalSiteForm
  },
  data () {
    return {
      breadcrumbs: [
        { text: '処分事業場一覧（再資源）', disabled: false, to: '/driver/masters/final_disposal_sites', exact: true },
        { text: '処分事業場追加（再資源）', disabled: true, to: '' },
      ],

    }
  },
  created() {
  },
  methods: {}
}
</script>
